/*
 * @Author: your name
 * @Date: 2020-04-22 10:08:34
 * @LastEditTime: 2020-05-12 16:36:07
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \frontend\modules\@cloudpivot\form\src\components\Attachment\schema.ts
 */
import { DataType } from "../../../typings";
import { baseUploadOptions } from "../../../component-schema";
import i18n from "../../../i18n";
export default {
    $id: "attachment",
    type: DataType.Object,
    $ref: baseUploadOptions.$id,
    properties: {
        widgetType: {
            type: DataType.Number,
            title: i18n.t('dataitem.ControlType').toString(),
        },
        dataItemType: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemType').toString(),
        },
        fileTypes: {
            type: DataType.String,
            title: i18n.t('dataitem.FileTypeLimit').toString(),
            tip: {
                content: i18n.t('dataitem.FileTypeLimitTips').toString(),
                icon: "question-circle-o",
            }
        },
        dataLinkage: {
            type: DataType.String,
            title: i18n.t('dataitem.DataLinkage').toString(),
        },
        displayTemplate: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.AttachmentTemplate').toString(),
            default: true,
        },
        templateFile: {
            type: DataType.String,
            title: i18n.t('dataitem.UploadTemplate').toString(),
        },
        labelVisible: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.LabelVisible').toString(),
            default: true,
        },
    },
};
